import { gql } from "@apollo/client"

export const GET_WIDGET_DATA_QUERY = gql`
  query getWidgetData($data: WidgetQueryInput!) {
    widgets {
      getData(data: $data) {
        data {
          name
          value
        }
      }
    }
  }
`

export const GET_WIDGET_DEFINITIONS_QUERY = gql`
  query getWidgetDefinitions($data: WidgetDefinitionInput!) {
    widgets {
      getDefinitions(data: $data) {
        name
        widgetName
        availableFilters
      }
    }
  }
`
